import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import { getDate } from '@/finsight/ui/components/deals/DealsList/DealHeader/helpers';
import IDealHeader from '@/finsight/ui/components/deals/DealsList/DealHeader/IDealHeader';

import styles from '@/finsight/ui/components/deals/DealsList/DealHeader/dealHeader.scss';

interface IDatesProps {
  deal: IDealHeader,
}

const Dates = ({ deal }: IDatesProps) => (
  <div className={ styles.datesCol } data-test="dealRowDates">
    { !!deal.pricingDate && (
      <Tooltip content="Issue Date">
        <span className={ styles.date }>
          { getDate(deal.pricingDate) }
        </span>
      </Tooltip>
    ) }

    { !deal.pricingDate && deal.announcedDate && (
      <Tooltip content="Announced Date">
        <span className={ styles.date }>
          { getDate(deal.announcedDate) }
        </span>
      </Tooltip>
    ) }
  </div>
);

export default Dates;
